module.exports = __webpack_public_path__ + "img/cdkf1.9d2b72ee.jpg";